import { Button, Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';

const StatusEditButton = ({ readOnly, onEdit }) => {
    const { t } = useTranslation('vinExtraction');
    const button = (
        <Button onClick={onEdit} disabled={readOnly} icon={<i className="fi fi-rr-edit" aria-hidden="true" />}>
            {t('status.edit')}
        </Button>
    );

    // a disabled button fires no hover events, so the tooltip sits on a focusable wrapper
    return readOnly ? (
        <Tooltip title={t('status.editReadOnly')}>
            <span tabIndex={0}>{button}</span>
        </Tooltip>
    ) : (
        button
    );
};

export default StatusEditButton;
